import type { ConsentSignals } from '@/lib/consent/consent-signals';

import type { AnalyticsAdapter, CaptureOptions } from './types';

export class ConsoleAdapter implements AnalyticsAdapter {
  readonly name = 'console' as const;
  private style = 'color:#888;font-style:italic';

  constructor() {
    console.debug('%c[Analytics]%c init', this.style, '');
  }

  page(
    name: string,
    properties?: Record<string, unknown>,
    _options?: CaptureOptions,
  ) {
    console.debug(
      '%c[Analytics]%c page %s',
      this.style,
      '',
      name,
      ...(properties ? [properties] : []),
    );
  }

  track(
    event: string,
    properties?: Record<string, unknown>,
    _options?: CaptureOptions,
  ) {
    console.debug(
      '%c[Analytics]%c %s',
      this.style,
      '',
      event,
      ...(properties ? [properties] : []),
    );
  }

  trackException(
    error: unknown,
    additionalProperties?: Record<string, unknown>,
  ) {
    console.error(
      '[Analytics] Exception:',
      error,
      ...(additionalProperties ? [additionalProperties] : []),
    );
  }

  identify(userId: string, traits?: Record<string, unknown>) {
    console.debug(
      '%c[Analytics]%c identify %s',
      this.style,
      '',
      userId,
      ...(traits ? [traits] : []),
    );
  }

  reset() {
    console.debug('%c[Analytics]%c reset', this.style, '');
  }

  isReady(): boolean {
    return globalThis.document !== undefined;
  }

  setConsent(signals: ConsentSignals) {
    console.debug('%c[Analytics]%c consent', this.style, '', signals);
  }

  optIn() {}

  optOut() {}

  toggleSessionRecording(_toState: 'on' | 'off') {}
}

/**
 * Factory: always returns a Console adapter. The provider uses it as a
 * last-resort fallback when neither PostHog nor GA factories activated,
 * so local dev without env vars still shows events in the console.
 */
export function createConsoleAdapter(): AnalyticsAdapter {
  return new ConsoleAdapter();
}
